module.exports = __webpack_public_path__ + "img/home-nonconformities.d5214857.svg";